import { RootState } from 'src/ui/app/store';

export const isUnverifiedUser = () => (state: RootState) =>
  state.ui.verifiedUser === false;
